var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10342_58459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7583 51.775C10.2375 51.775 8.48751 50.0667 8.48751 46.5459V25.6084C8.48751 22.0875 10.2375 20.3792 13.7583 20.3792H21.6333V17.1709C21.6333 14.4417 23.3208 12.9417 26.1125 12.9417H36.7792C39.6333 12.9417 41.2792 14.4417 41.2792 17.1709V20.3792H49.1542C52.675 20.3792 54.425 22.0875 54.425 25.6084V46.5459C54.425 50.0667 52.675 51.775 49.1542 51.775H13.7583ZM23.1542 17.1084V20.3792H39.7583V17.1084C39.7583 15.4209 38.675 14.4209 36.8208 14.4209H26.05C24.2167 14.4209 23.1542 15.4209 23.1542 17.1084ZM13.7583 50.2542H17.0708V21.8792H13.7583C11.1958 21.8792 10.0292 23.0459 10.0292 25.65V46.5042C10.0292 49.0875 11.1958 50.2542 13.7583 50.2542ZM18.6125 50.2542H44.3V21.8792H18.6125V50.2542ZM49.1542 21.8792H45.8417V50.2542H49.1542C51.7167 50.2542 52.8625 49.0875 52.8625 46.5042V25.65C52.8625 23.0459 51.7167 21.8792 49.1542 21.8792Z",
    fill: "url(#paint0_linear_10342_58459)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7583 51.775C10.2375 51.775 8.48751 50.0667 8.48751 46.5459V25.6084C8.48751 22.0875 10.2375 20.3792 13.7583 20.3792H21.6333V17.1709C21.6333 14.4417 23.3208 12.9417 26.1125 12.9417H36.7792C39.6333 12.9417 41.2792 14.4417 41.2792 17.1709V20.3792H49.1542C52.675 20.3792 54.425 22.0875 54.425 25.6084V46.5459C54.425 50.0667 52.675 51.775 49.1542 51.775H13.7583ZM23.1542 17.1084V20.3792H39.7583V17.1084C39.7583 15.4209 38.675 14.4209 36.8208 14.4209H26.05C24.2167 14.4209 23.1542 15.4209 23.1542 17.1084ZM13.7583 50.2542H17.0708V21.8792H13.7583C11.1958 21.8792 10.0292 23.0459 10.0292 25.65V46.5042C10.0292 49.0875 11.1958 50.2542 13.7583 50.2542ZM18.6125 50.2542H44.3V21.8792H18.6125V50.2542ZM49.1542 21.8792H45.8417V50.2542H49.1542C51.7167 50.2542 52.8625 49.0875 52.8625 46.5042V25.65C52.8625 23.0459 51.7167 21.8792 49.1542 21.8792Z",
    fill: "white",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10342_58459",
    x1: 31.4667,
    y1: 6.40002,
    x2: 31.4667,
    y2: 57.0667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6560FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#803FCE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10342_58459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/Briefcase.245616c21351599873fa90995eb890a6.svg";
export { ForwardRef as ReactComponent };